
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import ConfirmDialog from './components/ConfirmDialog.vue';
import UploadButton from '@/components/UploadButton.vue';
import UserInfo from '@/components/UserInfo.vue';
import DatePicker from '@/components/DatePicker.vue';
import Order from '@/components/OrderComponent.vue';
import './assets/main.css';
import VueApexCharts from 'vue-apexcharts'


Vue.use(Vuetify, {
  theme: {
    primary: '#FF2E63',
    secondary: '#42DEE1',
    accent: '#EAEAEA'
}});

Vue.component('apexchart', VueApexCharts);
Vue.component("ConfirmDialog", ConfirmDialog);
Vue.component("UploadButton", UploadButton);
Vue.component("UserInfo", UserInfo);
Vue.component("DatePicker", DatePicker);
Vue.component("Order", Order)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
